import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {filterMapByKey} from '../../atUtils'

export const createWorkScheduleReducer = ({
    WORK_SCHEDULE = null
}) => {
    const selectedYear = WORK_SCHEDULE.SELECTED_YEAR || new Date().getFullYear()

    const initialState = {
        firstLoading: true,
        loading: false,
        selectedYear: selectedYear,
        defaultWorkSchedules: [],
        corporateDays: {},
        editingDays: {},

        defaultTimeZoneCountry: null,
        countries: [],
        loadingCountries: false,
    }

    return handleActions({
        [ActionTypes.LOAD_DATA]: (state) => ({
            ...state,
            loading: true,
        }),
        [ActionTypes.LOAD_DATA_SUCCESS]: (state) => ({
            ...state,
            firstLoading: false,
            loading: false,
        }),
        [ActionTypes.LOADED_DATA_SET]: (state, {payload: loadedData}) => ({
            ...state,
            defaultWorkSchedules: [...state.defaultWorkSchedules, ...loadedData.defaultWorkSchedules],
            corporateDays: {...state.corporateDays, ...loadedData.corporateDays},
        }),
        [ActionTypes.LOAD_DATA_FAILURE]: (state) => ({
            ...state,
            firstLoading: false,
        }),
        [ActionTypes.EDITING_DAYS_ADD]: (state, {payload: day}) => ({
            ...state,
            editingDays: {...state.editingDays, [day]: true}
        }),
        [ActionTypes.EDITING_DAYS_REMOVE]: (state, {payload: day}) => ({
            ...state,
            editingDays: filterMapByKey(state.editingDays, day)
        }),
        [ActionTypes.YEAR_SELECTED]: (state, {payload: selectedYear}) => ({
            ...state,
            selectedYear: selectedYear,
        }),
        [ActionTypes.CORPORATE_DAYS_SET]: (state, {payload: corporateDays}) => ({
            ...state,
            corporateDays: {...state.corporateDays, ...corporateDays},
        }),
        [ActionTypes.DEFAULT_WORK_SCHEDULES_SET]: (state, {payload: defaultWorkSchedules}) => ({
            ...state,
            defaultWorkSchedules: defaultWorkSchedules,
        }),
        [ActionTypes.CORPORATE_DAYS_REMOVE_BY_YEAR]: (state, {payload: year}) => ({
            ...state,
            corporateDays: filterMapByKey(state.corporateDays, year),
        }),
        [ActionTypes.CURRENT_COUNTRY_SET]: (state, {payload: defaultTimeZoneCountry}) => ({
            ...state,
            defaultTimeZoneCountry,
        }),
        [ActionTypes.LOAD_COUNTRIES]: (state) => ({
            ...state,
            loadingCountries: true,
        }),
        [ActionTypes.LOAD_COUNTRIES_SUCCESS]: (state, {payload: {defaultTimeZoneCountry, countries}}) => ({
            ...state,
            defaultTimeZoneCountry,
            countries,
            loadingCountries: true,
        }),
        [ActionTypes.LOAD_COUNTRIES_FAILURE]: (state) => ({
            ...state,
            loadingCountries: false,
        }),
    }, initialState)
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/reducer.js